var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencilV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_12081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.80273 19.1739V22.889C1.80273 23.2311 2.07159 23.5 2.41376 23.5H6.1288C6.28767 23.5 6.44653 23.4389 6.55652 23.3167L19.9013 9.9841L15.3186 5.4014L1.98604 18.734C1.86384 18.8562 1.80273 19.0028 1.80273 19.1739ZM23.4453 6.44015C23.9219 5.96355 23.9219 5.19365 23.4453 4.71705L20.5857 1.85745C20.1091 1.38085 19.3392 1.38085 18.8626 1.85745L16.6262 4.09381L21.2089 8.6765L23.4453 6.44015Z",
    fill: "#99439D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_12081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.802734 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilV2);
export default __webpack_public_path__ + "static/media/EditPencilV2.33e165550647e00cf8ed249c4ad141f8.svg";
export { ForwardRef as ReactComponent };